module.exports = __webpack_public_path__ + "img/UTKODA-14.2b95ad39.jpg";